import { Auth } from "aws-amplify";

export function loginAsDistributor(distributorId: string): Promise<void> {
  const portalUrl = process.env.REACT_APP_DISTRIBUTOR_PORTAL_URL;
  if (!portalUrl) {
    return Promise.reject(new Error("Distributor access is not configured."));
  }
  const origin = new URL(portalUrl).origin;
  const nonce = window.crypto.randomUUID();
  const url = new URL("/admin-access", origin);
  url.searchParams.set("nonce", nonce);

  return new Promise((resolve, reject) => {
    let child: Window | null = null;
    let sending = false;
    const cleanup = () => {
      window.clearTimeout(timer);
      window.removeEventListener("message", receive);
    };
    const timer = window.setTimeout(() => {
      cleanup();
      reject(new Error("Access timed out. Open the distributor again."));
    }, 30000);

    async function receive(event: MessageEvent) {
      if (
        event.origin !== origin
        || event.source !== child
        || event.data?.nonce !== nonce
      ) {
        return;
      }
      if (event.data?.type === "distributor-admin-access-received") {
        cleanup();
        resolve();
        return;
      }
      if (event.data?.type === "distributor-admin-access-failed") {
        cleanup();
        reject(new Error(event.data.message || "Distributor access failed."));
        return;
      }
      if (event.data?.type !== "distributor-admin-ready" || sending) {
        return;
      }
      sending = true;
      try {
        const session = await Auth.currentSession();
        const token = session.getIdToken();
        child?.postMessage({
          type: "distributor-admin-access",
          nonce,
          distributorId,
          token: token.getJwtToken(),
          expiresAt: token.getExpiration(),
        }, origin);
      } catch (error) {
        cleanup();
        reject(error);
      }
    }

    window.addEventListener("message", receive);
    child = window.open(url.toString(), "_blank");
    if (!child) {
      cleanup();
      reject(new Error("Allow pop-ups to open the Distributor Portal."));
    }
  });
}
